import { type PriceTaxDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { pricesAndTaxesSelector } from '../selectors/pricesAndTaxesSelector';
import { atom } from 'recoil';

export const priceTaxAtom = atom<PriceTaxDTO>({
    key: 'priceTax',
    default: pricesAndTaxesSelector
});
